import { ROUTE } from "../../routes";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { DigioKycStatus } from "../../configs/constants";
import { WIDGET } from "@voltmoney/schema";
import { nextStepCredStepper } from "../../configs/utils";
import _ from 'lodash';
let pollInterval;
let responseFromDigio;
let isPopupShown = false;
export const GoToNumber = async (action, _datastore, { navigate, goBack }) => {
    // await goBack();
    await AsyncStorage.setItem('first_time', 'true');
    navigate(ROUTE.SPLASH_SCREEN);
};
export const closeModal = async (action, _datastore, { goBack, showPopup, navigateWithClear }) => {
    // goBack()
    await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
        failedModal: true,
        failedTitle: 'KYC verification canceled',
        failedSubTitle: 'KYC verification is required for the completion of your loan application',
        failedButtonTitle: 'Try again'
    });
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
    await hidePopup();
};
export const successVerification = async (action, _datastore, { hidePopup, navigateWithClear }) => {
    isPopupShown = true;
    hidePopup();
    const routeObj = await nextStepCredStepper();
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const digioCallback = async (action, datastore, { network, showPopup, goBack, removeWidgets, navigateWithClear }) => {
    responseFromDigio = action.payload;
    const type = action.payload.type;
    const error = action.payload.error;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : userContextResponse.data.linkedApplications[0].applicationId;
    let coBorrowerAccountId;
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
    if (await AsyncStorage.getItem("application_id") !== null) {
        coBorrowerAccountId = updatedApplicationResponse.data.currentCoBorrowerAccountId;
    }
    else {
        coBorrowerAccountId = userContextResponse.data.linkedApplications[0].currentCoBorrowerAccountId;
    }
    if (error !== "user_cancelled") {
        await network.get(`${api.coBorrowerDigioKycCheckRequestStatusOnCallBackV2}${applicationId}/${coBorrowerAccountId}`, {
            headers: await getAppHeader(),
        })
            .then(async (response) => {
            if (response.status === 200 &&
                response.data.stepResponseObject ===
                    DigioKycStatus.COMPLETED) {
                await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                    successModal: true,
                    successTitle: 'KYC done successfully',
                    successSubTitle: ' ',
                    successButtonTitle: 'Continue'
                });
                removeWidgets(ROUTE.DIGIO_MODAL_CO_BORROWER, [
                    { id: "digio", type: WIDGET.CO_BORROWER_DIGIO_MOBILE }
                ]);
            }
            else if (error === 'user_cancelled') {
                await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                    failedModal: true,
                    failedTitle: 'KYC verification canceled',
                    failedSubTitle: 'Please try again in sometime',
                    failedButtonTitle: 'Try again'
                });
            }
            else if (_.get(response, 'response.status', false) === 400) {
                const errorResponseData = _.get(response, 'response.data', false);
                if (_.get(response, 'response.data.voltErrorCode', false) === "DIGIO_PAN_MISMATCH") {
                    removeWidgets(ROUTE.DIGIO_MODAL_CO_BORROWER, [
                        { id: "digio", type: WIDGET.CO_BORROWER_DIGIO_MOBILE }
                    ]);
                    await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                        failedModal: true,
                        failedTitle: 'KYC verification failed',
                        failedSubTitle: errorResponseData.message,
                        failedButtonTitle: 'Try again'
                    });
                }
                else {
                    await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                        failedModal: true,
                        failedTitle: 'KYC verification failed',
                        failedSubTitle: 'Please try again later',
                        failedButtonTitle: 'Try again'
                    });
                }
            }
            else if (_.get(response, 'response.status', false) === 400) {
                const errorResponseData = _.get(response, 'response.data', false);
                if (_.get(response, 'response.data.voltErrorCode', false) === "DIGIO_PAN_MISMATCH") {
                    removeWidgets(ROUTE.DIGIO_MODAL_CO_BORROWER, [
                        { id: "digio", type: WIDGET.CO_BORROWER_DIGIO_MOBILE }
                    ]);
                    await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                        failedModal: true,
                        failedTitle: 'Verification failed!',
                        failedSubTitle: errorResponseData.message,
                        failedButtonTitle: 'Try again'
                    });
                }
                else {
                    await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                        failedModal: true,
                        failedTitle: 'KYC verification canceled',
                        failedSubTitle: 'Please try again later',
                        failedButtonTitle: 'Try again'
                    });
                }
            }
            else {
                console.log("Digio process not started");
            }
        });
    }
};
